import * as React from 'react';
import { Box } from "@mui/system"
import { Button, Tooltip } from "@mui/material";
import Grid from "@mui/material/Grid2"
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import RentalItemCalendarModal from './modals/RentalItemCalendarModal';
import { useTheme } from '@emotion/react';


export default function RentalItemRow({ item, cart, addToCartFunction, editButtonFunction, onClickFunction, showCalendar }) {
    const theme = useTheme()
    const [showCalendarModal, setShowCalendarModal] = React.useState(false)

    const availability_class = item.available ? `reservation-status-available` : `reservation-status-unavailable`
    var inCart = undefined
    if (addToCartFunction) {
        inCart = undefined !== cart.find((cart_item) => item.id === cart_item.id)
    }

    return (
        (<Box>
            <Tooltip title={item.reservation_tooltip}>
                <Grid container alignItems="center" className={availability_class} sx={{ border: 1, mb: '2px', height: '75px', "&:hover": { cursor: 'pointer', backgroundColor: theme.palette.grey.light, transition: 'background-color 0.2s ease' } }} onClick={() => onClickFunction(item)}>
                    <Grid size={1}>
                        {item.image_path !== undefined && item.image_path !== null && item.image_path !== "" &&
                            <Box component="img" alt={"Rental Item"} src={`/customerimages/client/${item.client_id}/rentalitems/${item.id}/${item.image_path}`} sx={{ maxHeight: '75px' }} />
                        }
                        {(item.image_path === undefined || item.image_path === null || item.image_path === "") &&
                            <Box component="img" alt={"Rental Item"} src={`/noimage.png`} sx={{ maxHeight: '75px', display: 'block' }} />
                        }
                    </Grid>
                    <Grid size="grow">
                        <span style={{ fontSize: '1.5em' }}><b>{item.unique_name}</b></span>
                        {item.bulk_type &&
                            <span style={{ fontSize: '1.0em' }}>(x{item.max_available}/{item.total_quantity})</span>
                        }
                    </Grid>
                    <Grid sx={{ pr: 2, pl: 1 }} size="auto">
                        <span>{item.location.name}</span>
                    </Grid>
                    <Grid sx={{ pr: 2, pl: 1 }} size="auto">
                        <span>{item.currently_checked_out ? 'Checked Out' : 'Available'}</span>
                    </Grid>
                    {showCalendar &&
                        <Grid sx={{ pr: 2, pl: 1 }} size="auto">
                            <Button onClick={(e) => { e.stopPropagation(); setShowCalendarModal(true) }}>
                                <CalendarTodayIcon />
                            </Button>
                        </Grid>
                    }
                    {addToCartFunction &&
                        <Grid sx={{ pr: 2, pl: 1 }} size="auto">
                            {inCart &&
                                <span><b>IN CART</b></span>}
                            {!inCart &&
                                <Button variant="contained" onClick={(e) => { e.stopPropagation(); addToCartFunction(item) }}>
                                    <AddShoppingCartIcon /> <Box sx={{ pl: 1 }}>Add to Cart</Box>
                                </Button>}
                        </Grid>
                    }
                    {editButtonFunction &&
                        <Grid sx={{ pr: 2, pl: 1 }} size="auto">
                            <Button variant="contained" onClick={(e) => { e.stopPropagation(); editButtonFunction(item) }}>
                                <ModeEditIcon /> <Box sx={{ pl: 1 }}>Edit</Box>
                            </Button>
                        </Grid>
                    }
                </Grid>
            </Tooltip>
            <RentalItemCalendarModal
                item={item}
                open={showCalendarModal}
                closeModal={() => setShowCalendarModal(false)}
            />
        </Box>)
    );
}